/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import {Modal} from 'react-overlays';
import Button from '../../common/Button';

const StatePlanMessages = ({messages, showModal, hideModal}) => {

  let statePlanMessages = [];

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 'auto',
    backgroundColor: '#000',
    opacity: 0.5
  };

  if (messages && messages.length && messages.length > 0) {
    let i = 0;
    statePlanMessages = messages.map(stateMessage => {
      i++;
      if (stateMessage.state) {
        return (
          <p className="state-plan-message" key={i}>
            <b>{stateMessage.state}</b>
            {stateMessage.message}
          </p>
        );
      } else {
        return (<p
          className="state-plan-message"
          key={i}
          dangerouslySetInnerHTML={{
          __html: stateMessage.message
        }}/>);
      }

    });
  }

  return (
    <Modal
      className="state-plan-modal"
      backdropStyle={backdropStyle}
      show={showModal}
      onHide={hideModal}>
      <div className="state-plan-modal-dialog">
        <h3>Notice</h3>
        <div className="state-plan-messages">
          {statePlanMessages}
        </div>
        <Button
          className="state-plan-modal-button"
          onClick={hideModal}
          value="OK"
          disabled={false}/>
      </div>
    </Modal>
  );
};

StatePlanMessages.propTypes = {
  messages: PropTypes.array.isRequired,
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired
};

export default StatePlanMessages;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentManagement/StatePlanMessages.js
 **/